import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "command-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { d: "M4.5 2.5a2 2 0 0 1 2 2v2h-2a2 2 0 1 1 0-4Zm8 0a2 2 0 0 0-2 2v2h2a2 2 0 1 0 0-4Zm-8 12a2 2 0 0 0 2-2v-2h-2a2 2 0 1 0 0 4Zm8 0a2 2 0 0 1-2-2v-2h2a2 2 0 1 1 0 4Z" }),
        React.createElement("path", { fill: "currentColor", fillOpacity: 0.2, d: "M10.5 10.5v-4h-4v4z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
